<template>
    <div class="launch-page">
        <!-- banner -->
        <campaign-sections></campaign-sections>

        <!-- Page Description -->
        <div class="description-section">
            <div class="container p-l-30 p-r-30">
                <div class="row align-items-center">
                    <div class="col-lg-6 col-md-12">
                        <div class="description-img mb-5 mb-lg-0">
                            <img class="img-fluid" src="@/assets/images/launch-page/campaign-section.svg" alt="">
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-12">
                        <div class="description-text campaign-text pl-0 pl-lg-5">
                            <p>Easily engage your <strong>membership organisations, closed communities, alumni associations
                                    and Other associations and groups</strong> to raise funds for an idea, project or a
                                cause.</p>
                        </div>
                    </div>
                    <div class="col-12 full-section">
                        <p class="text-center bg-body">Craft your <strong class="text-dark-orange">campaign pitch</strong>
                            into a web page, <strong class="text-dark-orange">raise capital</strong> from hundreds or even
                            thousands of investors online, and <strong class="text-dark-orange">fund the next phase</strong>
                            of your growth with a <strong class="text-dark-orange">bigger and stronger community</strong>
                            behind you.</p>
                    </div>
                </div>
            </div>
        </div>

        <!-- join-the-community-->
        <join-community></join-community>

    </div>
</template>
<script>
export default {
    name: "LaunchCampaignMainComponent",
    components: {
        'campaign-sections': () => import("@/components/frontend/launch-campaign/CampaignBanner.vue"),
        'join-community': () => import("@/components/core/JoinCommunity.vue"),
    }
}
</script>
<style>.page-loader-wrapper {
    display: none;
}</style>